<template>
  <v-speed-dial v-model="fabLinks" open-on-hover absolute bottom right>
    <template v-slot:activator>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-model="fabLinks"
            color="primary"
            dark
            fab
            :disabled="!nasIsActive"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon v-if="fabLinks"> mdi-close </v-icon>
            <v-icon v-else> mdi-link </v-icon>
          </v-btn>
        </template>
        <span> Liens de prévisualisation du portail </span>
      </v-tooltip>
    </template>

    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          small
          color="#fec40d"
          :href="baseUrl + 'login-url.php?id=' + nas.nasIdentifier"
          target="_blank"
          v-bind="attrs"
          v-on="on"
        >
          <span class="text-body-1 font-weight-medium"> L </span>
        </v-btn>
      </template>
      <span>Login Page</span>
    </v-tooltip>

    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          small
          color="#281E87"
          :href="baseUrl + 'welcome-url.php?id=' + nas.nasIdentifier"
          target="_blank"
          v-bind="attrs"
          v-on="on"
        >
          <span class="text-body-1 font-weight-medium"> W </span>
        </v-btn>
      </template>
      <span>Welcome Page</span>
    </v-tooltip>

    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          small
          color="#fe4d0d"
          :href="
            baseUrl +
            'login-url.php?id=' +
            nas.nasIdentifier +
            '&errmsg=Authentication%20failed'
          "
          target="_blank"
          v-bind="attrs"
          v-on="on"
        >
          <span class="text-body-1 font-weight-medium"> E </span>
        </v-btn>
      </template>
      <span>Error Page</span>
    </v-tooltip>
  </v-speed-dial>
</template>
<script>
import { ref, computed } from "@vue/composition-api";
export default {
  props: {
    nas: [Object, Boolean],
  },
  setup(props) {
    /* Variables */
    const baseUrl = config.VUE_APP_API_PUBLIC;
    const fabLinks = ref(false);

    /* Computed */
    const nasIsActive = computed(function () {
      return props.nas.active > 0;
    });

    return {
      baseUrl,
      fabLinks,
      nasIsActive,
    };
  },
};
</script>
